import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Filter } from '../filter.interface';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SharedService } from '../../shared-services/shared.service';

@Component({
  selector: 'app-filter-user',
  templateUrl: './filter-user.component.html',
  styleUrls: ['./filter-user.component.scss'],
})
export class FilterUserComponent implements OnInit, OnDestroy {
  loading: boolean = false;
  departments: { id: number; name: string; numberOfUsers: number }[] = [];

  private readonly subscription: Subscription = new Subscription();

  @Input() filter: Filter;

  @Output() filterEvent: EventEmitter<Filter> = new EventEmitter<Filter>();

  constructor(private readonly sharedService: SharedService) {}

  ngOnInit(): void {
    this.getDepartments();
  }

  getDepartments() {
    this.loading = true;

    this.subscription.add(
      this.sharedService
        .getAllDepartments()
        .pipe(finalize(() => (this.loading = false)))
        .subscribe({
          next: (res: any) => {
            this.departments = res['responseResult'];
          },
          error: () => {},
        })
    );
  }

  setUser(user: any) {
    this.filterEvent.emit({
      ...this.filter,
      user: {
        name: user?.name,
        value: user?.id ?? null,
      },
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
